<template>
  <div class="new_group_send">
    <el-page-header @back="goBack">
      <template #content>
        <strong class="title">企微群发</strong>
      </template>
    </el-page-header>

    <div class="content_box">
      
      <el-form :model="form" label-width="auto" style="max-width: 600px">
        <el-form-item label="任务名称" required>
          <el-input v-model="form.name" maxlength="50" :autofocus="!isEditState" :formatter="taskNameParser" :parser="taskNameParser"/>
        </el-form-item>
        <el-form-item label="群发类型" required>
          <el-radio-group v-model="form.region" @change="regionChange">
            <el-radio value="personal">发送给学员微信</el-radio>
            <el-radio value="wxGroup">发送给学员微信群</el-radio>
          </el-radio-group>
          <!-- <el-select v-model="form.region" placeholder="请选择群发类型" @change="regionChange">
            <el-option label="发送给学员" value="personal" />
            <el-option label="发送给学员群" value="wxGroup" />
          </el-select> -->
          <el-alert title='提示：每个任务只能选择一种群发类型，可下拉选择更换群发类型' type="warning" class="alert" :closable="false"></el-alert>
        </el-form-item>
      </el-form>
      <div class="tab_box" v-if="form.region == 'personal'">
        <el-tabs v-model="personalData.tabValue" type="card"  class="demo-tabs" @edit="handlePersonalTabsEdit" closable :addable="personalData.allTabData.length < mostTabNumber">
          <el-tab-pane v-for="item in personalData.allTabData" :key="item.name" :label="item.title" :name="item.name">
            <div class="edit_content_box">
              <PersonalContentEdit :key="item.name" :taskContents="item" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="tab_box" v-if="form.region == 'wxGroup'">
        <el-tabs v-model="wxGroupData.tabValue" type="card"  class="demo-tabs" @edit="handleWxGroupTabsEdit" closable :addable="personalData.allTabData.length < mostTabNumber">
          <el-tab-pane v-for="item in wxGroupData.allTabData" :key="item.name" :label="item.title" :name="item.name"
            :lazy="true">
            <div class="edit_content_box">
              <WxGroupContentEdit :key="item.name" :taskContents="item" />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="footer_box">
      <div class="top_box">
        <div class="msg_box">
          共发送<span>{{ studentNumber }}</span>个学员，<span>{{ msgNumber }}</span>条消息
          
        </div>
        <div class="btn_box">
          <el-button @click="goBack">取消</el-button>
          <el-button type="primary" plain @click="save" :loading="saving" :disabled="isDataEmpty">保存</el-button>
          <el-button @click="showPreview" :disabled="isDataEmpty">点此预览</el-button>
          <el-button type="primary" @click="send" :disabled="isDataEmpty">发送</el-button>
        </div>
      </div>
      <div class="bot_box">
        注意：开始发送后会占用电脑，请合理安排时间
      </div>
    </div>
  </div>
  <PersonalPreview v-model="showPersonalPreview" :tableData='personalPreviewData' @send="startSentPersonalMsg">
  </PersonalPreview>
  <WxGroupPreview v-model="showWxGroupPreview" :tableData='wxGroupPreviewData' @send="startSentWxGroupMsg">
  </WxGroupPreview>

  <SendConfirmDialog v-model="showSendConfirm" :saveData="saveData" :studentNumber="studentNumber"
    :msgNumber="msgNumber" />


</template>

<script setup>
import PersonalContentEdit from './components/personalContentEdit.vue';
import WxGroupContentEdit from './components/wxGroupContentEdit.vue';
import PersonalPreview from './components/personalPreview.vue'
import WxGroupPreview from './components/wxGroupPreview.vue'
import SendConfirmDialog from './components/sendConfirmDialog.vue'
import { computed, reactive, ref, toRefs, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getUid } from '@/utils/util.js'
import { getPreviewData } from '@/utils/resolveData.js'
import { saveTask, taskContentApi } from '@/api/qwSendMessage';
import { ElNotification, ElMessageBox } from 'element-plus';
import { useTaskListStore } from '@/store/taskList.js'
const taskListStore = useTaskListStore()
const mostTabNumber = 10;
const regionKV = {
  'personal': 0,
  'wxGroup': 2
}
const router = useRouter();
const route = useRoute();
console.log(route)
// do not use same name with ref
const form = reactive({
  name: '课后服务群发任务',
  region: 'personal'
})
const studentNumber = ref(0);
const msgNumber = ref(0);
const showPersonalPreview = ref(false)
const showWxGroupPreview = ref(false)
const showSendConfirm = ref(false);
const saving = ref(false)
const isDataEmpty = ref(true);
let taskId = route.query.taskId || '';
const isEditState = computed(()=> !!route.query.taskId)
// 这里目前需要两套数据 一套时给 好友群发用的  一套是给多群群发用的
const personalInitTabId = getUid();
const personalData = reactive({
  tabValue: personalInitTabId,
  allTabData: [
    {
      title: '群发1',
      name: personalInitTabId,
      tabId: personalInitTabId,
      sendTarget: [
        // {
        //   studentName: '张三',
        //   studentCode: 'JS345345',
        //   nickName: '小张',
        //   receiveName: '小张3号',
        //   groupName: 'A组',
        //   groupId: '131312',
        // },
        // {
        //   studentName: '张三3',
        //   studentCode: 'JS3453453',
        //   nickName: '小张4',
        //   receiveName: '小张5号',
        //   groupName: 'A组6',
        //   groupId: '1313126',
        // }
      ],
      sendContent: [
        // {
        //   msgType: 'text',
        //   // showContent: `fawfatetsgsdf<span class="qqq"><span class="input_tag" contenteditable="false">#学生编码#</span><span class="space">​</span></span> gsdfgsg<span class="qqq"><span class="input_tag" contenteditable="false">#学生姓名#</span><span class="space">​</span></span> dgsgsdfgsgf<span class="qqq"><span class="input_tag" contenteditable="false">#学生昵称#</span><span class="space">​</span></span> `,
        //   sendContent: "fawfatetsgsdf#学生编码#​ gsdfgsg#学生姓名#​ dgsgsdfgsgf#学生昵称#​ ",
        // },
        // {
        //   msgType: 'file',
        //   filePaths: [{ path: '/usr/renjinhui/document/qqqq/1.pdf' }, { path: '/usr/renjinhui/document/www/2.pdf' }],
        // },
        // {
        //   msgType: 'folder',
        //   sendContent: [{
        //     studentName: '张三',
        //     studentCode: "JS345345",
        //     filePaths: [{ path: '/usr/renjinhui/document/qqqq/张三.pdf' }, { path: '/usr/renjinhui/document/www/张三2.pdf' }],
        //   }],
        //   // filePaths: [{ path: '/usr/renjinhui/document/qqqq/张三.pdf' }, { path: '/usr/renjinhui/document/www/张三2.pdf' }],
        // },
      ]
    }
  ]
});
const wxGroupInitTabId = getUid();
const wxGroupData = reactive({
  tabValue: wxGroupInitTabId,
  allTabData: [
    {
      title: '群发1',
      name: wxGroupInitTabId,
      tabId: wxGroupInitTabId,
      sendTarget: [
        // {
        //   studentName: '张三',
        //   studentCode: 'JS345345',
        //   nickName: '小张',
        //   receiveName: '小张3号',
        //   groupName: 'A组',
        //   groupId: '131312',
        // }
      ],
      sendContent: [
        // {
        //   msgType: 'text',
        //   // showContent: `fawfatetsgsdf<span class="qqq"><span class="input_tag" contenteditable="false">#学生编码#</span><span class="space">​</span></span> gsdfgsg<span class="qqq"><span class="input_tag" contenteditable="false">#学生姓名#</span><span class="space">​</span></span> dgsgsdfgsgf<span class="qqq"><span class="input_tag" contenteditable="false">#学生昵称#</span><span class="space">​</span></span> `,
        //   sendContent: "fawfatetsgsdf#学生编码#​ gsdfgsg#学生姓名#​ dgsgsdfgsgf#学生昵称#​ ",

        // }
      ]
    }
  ]
});
// 预览数据
const personalPreviewData = ref([]);
const wxGroupPreviewData = ref([]);


const saveData = ref({});

const taskNameParser = (value)=>value.replace(/\\|\/|\:|\*|\?|\<|\"|\'|\>|\|/g,'')


//根据ID获取数据
const getContentById = () => {
  if (!taskId) return;
  taskContentApi(taskId).then(res => {
    console.log(190, res)
    form.name = res.taskName;
    let firstTab = res.groupSendObjects[0];
    if (firstTab) {
      form.region = firstTab.sendType == 0 ? 'personal' : 'wxGroup';
      if (form.region == 'personal') {
        personalData.tabValue = firstTab.tabId;
        personalData.allTabData = res.groupSendObjects.map((item, index) => {
          return {
            ...item,
            title: "群发" + (index + 1)
          }
        })
      } else {
        wxGroupData.tabValue = firstTab.tabId;
        wxGroupData.allTabData = res.groupSendObjects.map((item, index) => {
          return {
            ...item,
            title: "群发" + (index + 1)
          }
        })
      }
    }
  })
}
getContentById()


const resolveSaveData = () => {
  let groupSendObjects = [];
  let studentMessageDetails = [];
  console.log('(form.region', form.region);
  if (form.region == 'personal') {
    // console.log('save -- formData:', form)
    // console.log('save -- personalPreviewData:', personalPreviewData)
    groupSendObjects = personalData.allTabData.map(item => {
      item.sendType = regionKV[form.region];
      // item.sendContent = item.sendContent.filter(item2=>item2.filePaths?.length || item2.sendContent?.length)

      return {...item,sendTarget:item.sendTarget.map(target=>{target.receiveNameSelectList=undefined;target.receiveType=0;return target})};
    });;
    studentMessageDetails = personalPreviewData.value
  } else {
    console.log('save -- formData:', form)
    console.log('save -- wxGroupPreviewData:', wxGroupPreviewData)
    groupSendObjects = wxGroupData.allTabData.map(item => {
      item.sendType = regionKV[form.region];
      // item.sendContent = item.sendContent.filter(item2=>item2.filePaths?.length || item2.sendContent?.length)
      return {...item,sendTarget:item.sendTarget.map(target=>{
        target.receiveNameSelectList=undefined;
        target.chatGroupName=target.receiveName;
        target.receiveType=2;
        return target
      })};
    });
    studentMessageDetails = wxGroupPreviewData.value.map(item => {
      item.chatGroupName = item.receiveName;
      const obj = {
        ...item,
        // receiveName:undefined // 多加兼容
      }
      return obj
    });
  }
  // console.log('studentMessageDetails', studentMessageDetails)
  groupSendObjects = groupSendObjects.map(item=>{
    const realSendContent = item.sendContent.filter(item2=>item2.filePaths?.length || item2.sendContent?.length)
    return {
      ...item,
      sendContent: realSendContent
    }
  })
  return {
    creatorStaffId: sessionStorage.getItem('currentStaffId'),
    taskName: form.name,
    taskId: taskId || undefined,
    taskType: 1,
    groupSendObjects,
    studentMessageDetails
  }
}

const tabDel = (personaOrWxGrouplData,item)=>{
  let closeTabIndex = null;
    // console.log(personalData.tabValue,personalData.tabValue)
    personaOrWxGrouplData.allTabData.some((data, index) => {
      if (data.tabId == item) {
        closeTabIndex = index;
        if (data.sendTarget.length || data.sendContent.length) {
          // 有内容的话 删除提醒
          ElMessageBox.confirm(
            '当前分组下含有您已编辑的内容，是否仍然删除？',
            '提醒',
            {
              type: 'warning',
            }
          )
            .then(() => {
              if (personaOrWxGrouplData.tabValue == item) {
                const nextTabData = personaOrWxGrouplData.allTabData[index + 1] || personaOrWxGrouplData.allTabData[index - 1];
                if (nextTabData) {
                  personaOrWxGrouplData.tabValue = nextTabData.tabId;
                }
              }
              personaOrWxGrouplData.allTabData.splice(closeTabIndex, 1);
              personaOrWxGrouplData.allTabData.forEach((item,index)=>item.title = "群发"+(index+1))
            })
        } else {
          if (personaOrWxGrouplData.tabValue == item) {
            const nextTabData = personaOrWxGrouplData.allTabData[index + 1] || personaOrWxGrouplData.allTabData[index - 1];
            if (nextTabData) {
              personaOrWxGrouplData.tabValue = nextTabData.tabId;
            }
          }
          personaOrWxGrouplData.allTabData.splice(closeTabIndex, 1);
          personaOrWxGrouplData.allTabData.forEach((item,index)=>item.title = "群发"+(index+1))
        }
        return true
      }
    })
}

// 好友群发 新增群发编辑
const handlePersonalTabsEdit = (item, action) => {
  console.log(item, action)
  if (action == 'add') {
    const newTabId = getUid();;
    personalData.tabValue = newTabId;
    personalData.allTabData.push({
      title: '群发' + (personalData.allTabData.length + 1),
      name: newTabId,
      tabId: newTabId,
      sendTarget: [],
      sendContent: []
    })
  } else {
    tabDel(personalData,item)
  }

}

// 多群群发 新增群发编辑
const handleWxGroupTabsEdit = (item, action) => {
  console.log(item, action)
  if (action == 'add') {
    const newTabId = getUid();;
    wxGroupData.tabValue = newTabId;
    wxGroupData.allTabData.push({
      title: '群发' + (wxGroupData.allTabData.length + 1),
      name: newTabId,
      tabId: newTabId,
      sendTarget: [],
      sendContent: []
    })
  } else {
    tabDel(wxGroupData,item)
  }
}

// 监听数据变化 来更新徐发送的学员及消息数目
watch([() => form.region, personalData, wxGroupData], () => {
  // console.log(6666,form.region)
  if (form.region == 'personal') {
    const studentList = getPreviewData(personalData)
    console.log('studentList:', studentList)
    console.log('personalPreviewData:', JSON.stringify(personalPreviewData.value))
    personalPreviewData.value = studentList.map(item=>{
      item.sendContents = item.sendContents.filter(item2=>item2.sendContent || item2.path)
      return item;
    });
    studentNumber.value = studentList.length;
    let total = 0;
    studentList.forEach(item => {
      total += item.sendContents.length;
    })
    msgNumber.value = total
  } else {
    const wxGroupList = getPreviewData(wxGroupData)
    console.log('wxGroupList:', wxGroupList)
    wxGroupPreviewData.value = wxGroupList.map(item=>{
      item.sendContents = item.sendContents.filter(item2=>item2.sendContent || item2.path)
      return item;
    });;
    studentNumber.value = wxGroupList.length;
    let total = 0;
    wxGroupList.forEach(item => {
      total += item.sendContents.length;
    })
    msgNumber.value = total
  }
  const saveData = resolveSaveData()
  if (saveData.groupSendObjects.some(item => item.sendTarget.length == 0 || item.sendContent.length == 0)) {
    isDataEmpty.value = true
  } else {
    isDataEmpty.value = false
  }

}, { deep: true, immediate: true })



const save = () => {
  // console.log('formData:', form)
  saving.value = true;
  const saveData = resolveSaveData()
  console.log('aveData.groupSendObjects', saveData.groupSendObjects)
  if(!form.name){
    saving.value = false;
    ElNotification({
      title: '警告',
      message: "任务名称不能为空",
      type: 'warning',
    })
    return;
  }
  if (saveData.groupSendObjects.some(item => item.sendTarget.length == 0 || item.sendContent.length == 0)) {
    saving.value = false;
    ElNotification({
      title: '警告',
      message: "发送学员和内容不能为空",
      type: 'warning',
    })
    return;
  }
  saveTask(saveData).then((taskId) => {
    saving.value = false;
    taskListStore.updateTaskList()
    console.log('----------taskId', taskId)
    taskListStore.setCurrentTaskTabId(taskId);
    goBack();
  }).catch(err => {
    console.log(JSON.stringify(err))
    window.bonreeJsBridge&&window.bonreeJsBridge?.setCustomLog("直接执行保存的错误信息：" + JSON.stringify(err));
    saving.value = false;
    ElNotification({
      title: '保存失败',
      message: err || '系统繁忙',
      type: 'error',
    })
  })
}

const send = () => {
  saveData.value = resolveSaveData();
  showSendConfirm.value = true;
}

const showPreview = () => {
  if (form.region == 'personal') {
    showPersonalPreview.value = true;
  } else {
    showWxGroupPreview.value = true;
  }
}
const startSentPersonalMsg = () => {
  showPersonalPreview.value = false
  send()
}
const startSentWxGroupMsg = () => {
  showWxGroupPreview.value = false;
  send()
}
const regionChange = ()=>{

}
const goBack = () => {
  router.back()
}
</script>

<style lang="less" scoped>
:deep(.el-page-header__header){
  width: 100%;
  .el-page-header__left{
    width:100%;
    .el-page-header__content{
      flex: auto;
      text-align: center;
    }
  }
}
.new_group_send {
  text-align: left;
  padding: 0 20px;
  box-sizing: border-box;
  width: 800px;
  margin: auto;
  background-color: #fff;
  height: 100vh;


  // overflow: hidden;
  .title {
    padding: 10px;
    height: 50px;
    box-sizing: border-box;
  }

  :deep(.el-page-header) {
    padding: 10px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #f6f6f6;
  }

  .content_box {
    margin-top: 10px;
    padding: 0 20px;
    height: calc(100vh - 150px);
    box-sizing: border-box;
    overflow: scroll;
    .alert{
      color: rgb(250, 173, 20);
    }
    .tab_box {
      // background-color: #f6f6f6;
    }

    :deep(.el-tabs__header) {
      // background-color: #fff;
      .el-tabs__item.is-active {
        // background-color: #f6f6f6;
      }
    }
  }

  .footer_box {
    height: 100px;
    box-sizing: border-box;
    border-top: 1px solid #ccc;
    padding-top: 10px;

    .top_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .bot_box {
      text-align: right;
      margin-top: 5px;
      color: #FFB200;
      font-size: 13px;
    }
  }
  :deep(.el-alert--warning) {
    padding: 2px 4px;
    background-color: #fff;
    .el-alert__title{
      font-size: 13px;
    }
  }
}
</style>